module.exports = JSON.parse('{"Primary":"Первичные","Recent":"Недавние","All":"Все"}')